import script from "./SessionModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SessionModal.vue?vue&type=script&setup=true&lang=js"

import "./SessionModal.vue?vue&type=style&index=0&id=21c3b046&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21c3b046"]])

export default __exports__